'use client'

import { useState } from 'react'

import { Avatar, Icon, IconComponent } from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { AUTH_LOGOUT_PATH } from '@common/core.const'

import { useSessionStore } from '@stores/session/session.store'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

export function AccountDrawer() {
  const {
    displayUserEmail,
    displayUserName,
    isAccountDrawerOpen,
    onClose,
    onProfileClick,
    setIsAccountDrawerOpen,
    showUserAvatar,
    userAvatarUrl,
  } = useMobileMenuContext()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleClose = () => setIsAccountDrawerOpen(false)

  const handleActionClick = (actionId: string, disabled?: boolean) => {
    if (disabled) return
    onProfileClick?.(actionId)
    onClose()
  }

  const handleLogout = () => {
    setIsLoggingOut(true)
    useSessionStore.getState().clearToken()
    window.location.href = AUTH_LOGOUT_PATH
  }

  return (
    <Dialog.Root open={isAccountDrawerOpen} onOpenChange={(open) => !open && !isLoggingOut && handleClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.appPickerOverlay} />
        <Dialog.Content className={styles.accountDrawer} data-testid={MOBILE_MENU_TEST_IDS.accountDrawer}>
          <div className={styles.accountDrawerHeader}>
            <div className={styles.appPickerDragHandle} />
            <Dialog.Title className={styles.accountDrawerTitleSection}>
              {showUserAvatar ? <Avatar size={48} src={userAvatarUrl} /> : null}
              <div className={styles.accountDrawerTitleText}>
                <span className={styles.accountDrawerName}>{displayUserName}</span>
                <span className={styles.accountDrawerEmail}>{displayUserEmail}</span>
              </div>
            </Dialog.Title>
            <div className={styles.appPickerDivider} />
          </div>

          <div className={styles.accountDrawerContent}>
            <button className={styles.accountDrawerItem} onClick={() => handleActionClick('settings')}>
              <IconComponent icon={Icon.SettingsRegular} size={24} className={styles.accountDrawerItemIcon} />
              <span className={styles.accountDrawerItemLabel}>Settings</span>
            </button>

            <button
              className={`${styles.accountDrawerItem} ${styles.disabled}`}
              onClick={() => handleActionClick('region', true)}
              disabled
            >
              <IconComponent icon={Icon.EarthRegular} size={24} className={styles.accountDrawerItemIcon} />
              <span className={styles.accountDrawerItemLabel}>Region</span>
            </button>

            <div className={styles.accountDrawerSeparator} />

            <button
              className={`${styles.accountDrawerItem} ${isLoggingOut ? styles.loading : ''}`}
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              <IconComponent
                icon={isLoggingOut ? Icon.DSSpinner : Icon.ArrowExitRegular}
                size={24}
                className={`${styles.accountDrawerItemIcon} ${isLoggingOut ? styles.spinning : ''}`}
              />
              <span className={styles.accountDrawerItemLabel}>{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
